import React from "react";
import classNames from "classnames";
import { SectionSplitProps } from "../../utils/SectionProps";
import SectionHeader from "./partials/SectionHeader";
import Image from "../elements/Image";
import { Link } from "react-router-dom";

const propTypes = {
  ...SectionSplitProps.types
};

const defaultProps = {
  ...SectionSplitProps.defaults
};

const DirectInstallProgramAspects = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    "features-split section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "features-split-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const splitClasses = classNames(
    "split-wrap",
    invertMobile && "invert-mobile",
    invertDesktop && "invert-desktop",
    alignTop && "align-top"
  );

  const sectionHeader = {
    title: "Program Aspects",
    paragraph: ""
  };

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>
            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-right"
                data-reveal-container=".split-item"
              >
                {/* <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Lightning fast workflow
                  </div> */}
                <h3 className="mt-0 mb-12 text-color-primary ">
                  {/* <Link
                    to="/services/installations"
                    style={{ color: "#1CB68B", textDecoration: "none" }}
                    onClick={() => {
                      window.scroll(0, 0);
                    }}
                  > */}
                  Certified Energy Efficiency Technicians
                  {/* </Link> */}
                </h3>
                <p className="m-0">
                  We provide professional technicians that are certified by the
                  Building Performance Institute (BPI).
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                {/* <Link
                  to="/services/installations"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                > */}
                <Image
                  title="U.S. Department of Energy"
                  src={require("./../../assets/images/assessor.jpeg")}
                  alt="Features split 02"
                  width={528}
                  height={396}
                />
                {/* </Link> */}
              </div>
            </div>

            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-right"
                data-reveal-container=".split-item"
              >
                {/* <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Lightning fast workflow
                  </div> */}
                <h3 className="mt-0 mb-12 text-color-primary ">
                  {/* <Link
                    to="/services/installations"
                    style={{ color: "#1CB68B", textDecoration: "none" }}
                    onClick={() => {
                      window.scroll(0, 0);
                    }}
                  > */}
                  Energy Efficiency Measures Evaluation {/* </Link> */}
                </h3>
                <p className="m-0">
                  Our Engineering Team provide a transparent and consistent
                  basis for calculating energy (kWh or therms), and demand (kW)
                  savings for measures based on Technical Resource Manuals
                  (TRM)s.
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                {/* <Link
                  to="/services/installations"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                > */}
                <Image
                  title="Photo by UX Indonesia on Unsplash"
                  src={require("./../../assets/images/ux-indonesia-8mikJ83LmSQ-unsplash.jpg")}
                  alt="Features split 02"
                  width={528}
                  height={396}
                />
                {/* </Link> */}
              </div>
            </div>
            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                {/* <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Lightning fast workflow
                  </div> */}
                <h3 className="mt-0 mb-12 text-color-primary">
                  {/* <Link
                    to="/services/audits"
                    style={{ color: "#1CB68B", textDecoration: "none" }}
                    onClick={() => {
                      window.scroll(0, 0);
                    }}
                  > */}{" "}
                  Direct Install {/* </Link> */}
                </h3>
                <p className="m-0">
                  Our technicians directly install Energy Efficiency Measures
                  such as: 
                  <ul>
                  <li>
                  Exterior Door Weatherstripping 
                    </li>
                    <li>
                    Door Sweeps
                    </li>
                    <li>
                    Big Gap Filler
                      </li>
                      <li>
                      Pipe Wrap
                      </li>   
                      <li>
                      Air Filter with Filter whistle
                      </li>
                      <li>
                      LED
                  Lighting
                      </li>
                      <li>
                      Power Outlet Gaskets – exterior walls
                      </li>
                  
                  </ul>
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  title="Photo by Carlos Muza on Unsplash"
                  src={require("./../../assets/images/iStock_000029695580XXXLarge_0.jpeg")}
                  alt="Features split 03"
                  width={528}
                  height={396}
                />
              </div>
            </div>
            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-right"
                data-reveal-container=".split-item"
              >
                {/* <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Lightning fast workflow
                  </div> */}
                <h3 className="mt-0 mb-12 text-color-primary ">
                  System of Record Energy Savings Reporting
                </h3>
                <p className="m-0">
                  We generate assessment reports for customers and to report the
                  program’s energy-savings for government/utility.
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  title="Photo by Petr Machacek on Unsplash"
                  src={require("./../../assets/images/carlos-muza-hpjSkU2UYSU-unsplash.jpg")}
                  alt="Features split 02"
                  width={528}
                  height={396}
                />
                <p></p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

DirectInstallProgramAspects.propTypes = propTypes;
DirectInstallProgramAspects.defaultProps = defaultProps;

export default DirectInstallProgramAspects;
